export const GAME_NAME = "PvPz.io";
export const GAME_VERSION = "2.0.0";
export const MAJOR_GAME_VERSION = GAME_VERSION.substring(0, 1);
export const MAX_PLAYERS = 20;

console.log("\n -- USING GAME VERSION DETAILS --");
console.log(`GAME_VERSION --> ${GAME_VERSION}`);
console.log(`MAJOR_GAME_VERSION --> ${MAJOR_GAME_VERSION}\n`);
